/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";
import L from "./Lang"
import BaseCom from "./BaseCom";
import { v4 as uuidv4 } from 'uuid';
import tinymce from 'tinymce/tinymce';
import 'tinymce/tinymce';
import 'tinymce/icons/default';
import 'tinymce/models/dom';
import 'tinymce/themes/silver';
import 'tinymce/plugins/code';
import 'tinymce/plugins/table';
import 'tinymce/plugins/link';
import 'tinymce/plugins/lists';
import 'tinymce/skins/ui/oxide/skin.min.css';
import { HTMLEditorLinkGlobal } from "./HTMLEditorLink";
import { HTMLEditorFieldGlobal } from "./HTMLEditorField";

class HTMLEditor extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            id: 't' + uuidv4().replace(/-/g, ''),
            value: this.props.defaultValue ?? this.props.value,
            selectIdx: 0
        };
    }

    componentDidMount() {
        setTimeout(() => {
            var ele = document.getElementById(this.state.id);
            if (ele) {
                var tox = ele.parentNode.getElementsByClassName('tox');
                if (tox.length === 0) {
                    tinymce.init({
                        skin: false,
                        selector: 'textarea#' + this.state.id,
                        readonly: this.props.disabled,
                        statusbar: false,
                        promotion: false,
                        menubar: false,
                        plugins: 'table code',
                        toolbar: 'formField customLink | bold italic underline | styles fontfamily fontsize | forecolor backcolor | alignleft aligncenter alignright alignjustify | table | bullist numlist outdent indent | removeformat | code',
                        table_toolbar: 'tableprops tabledelete | tableinsertrowbefore tableinsertrowafter tabledeleterow | tableinsertcolbefore tableinsertcolafter tabledeletecol',
                        setup: ed => {
                            this.ed = ed;
                            ed.on('change', e => {
                                let rng = ed.selection.getRng();
                                let selectIdx = rng.startOffset;
                                this.setState({ selectIdx: selectIdx, value: ed.getContent() });
                                if (this.props.onChange)
                                    this.props.onChange(ed.getContent());
                            });
                            ed.ui.registry.addButton('formField', {
                                icon: 'addtag',
                                onAction: () => {
                                    var preSel = ed.selection.getContent({ format: 'html' });
                                    var match = preSel.match(/<input([^>]+)>/);
                                    var info = {};
                                    if (match) {
                                        if (match.length >= 2) {
                                            match = match[1].matchAll(/([^=]+)="([^"]+)"/g);

                                            match = Array.from(match);

                                            match.forEach(i => {
                                                i[1] = i[1].trim();
                                                i[2] = i[2].trim();
                                                if (i[1] === "data-type")
                                                    info.fieldType = i[2];
                                                if (i[1] === "name")
                                                    info.fieldIdent = i[2];
                                                if (i[1] === "placeholder")
                                                    info.fieldName = i[2];
                                            });
                                        }
                                    }
                                    HTMLEditorFieldGlobal.show(info, v => {
                                        ed.insertContent('<input type="text" name="' + v.fieldIdent + '" placeholder="' + v.fieldName + '" data-type="' + v.fieldType + '" disabled="disabled" required="' + (v.required ? 'true' : 'false') + '" style="display: block; width: 100%;" />');
                                    });
                                }
                            });
                            ed.ui.registry.addButton('customLink', {
                                icon: 'link',
                                onAction: () => {
                                    var url = null;
                                    var preSel = ed.selection.getContent({ format: 'html' });
                                    var match = preSel.match(/<a href="([^"]+)">([^<]+)<\/a>/);
                                    if (match) {
                                        if (match.length >= 2)
                                            url = match[1];
                                    }
                                    HTMLEditorLinkGlobal.show(url, v => {
                                        var sel = ed.selection.getContent({ format: 'text' });
                                        if (!v)
                                            ed.insertContent(sel);
                                        else
                                            ed.insertContent('<a href="' + v + '""><L>' + sel + '</L></a>')
                                    });
                                }
                            });
                        }
                    });
                }
                else {
                    ele.style.display = 'none';
                }
            }
        }, 100);
    }

    componentWillUnmount() {
        tinymce.get(this.state.id)?.remove();
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.defaultValue !== this.props.defaultValue) {
            this.setState({ value: this.props.defaultValue });
        }
        if (prevProps.value !== this.props.value) {
            this.sel();
        }
        if (prevProps.disabled !== this.props.disabled) {
            if (this.props.disabled) {
                if (this.ed?.setMode)
                    this.ed.setMode('readonly');
            }
            else {
                if (this.ed?.setMode)
                    this.ed.setMode('designer');
            }
        }
    }

    sel = () => {
        if (this.props.linkValue && this.ed) {
            let bookmark = null;

            try {
                bookmark = this.ed.selection.getBookmark(2, true);
            }
            catch (e) {
            }

            this.ed.setContent(this.props.value);

            if (bookmark) {
                try {
                    this.ed.selection.moveToBookmark(bookmark);
                }
                catch (e) {
                }
            }
        }
    }

    render() {
        return <div id={this.state.id + '-wrapper'}>
            <textarea id={this.state.id} defaultValue={this.props.defaultValue ?? this.props.value} className={this.props.className} style={this.props.style}></textarea>
        </div>;
    }
}

export default HTMLEditor;